import useSWR from 'swr';
import config from '../config';

const { apiUrl } = config;

// Define a fetcher function that returns a Promise
const fetcher = (url) => fetch(url, {
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json',
    Authorization: 'test',
  },
  mode: 'cors',
})
  .then((res) => res.json())
  // If an error occurs, throw an Error with the error message
  .then((data) => {
    if (data.error) {
      throw new Error(data.error);
    }
    return data;
  })
  // If an error occurs, log the error message and reject the Promise with a new Error
  .catch((err) => {
    console.error(`useUser: Failed to fetch - error: ${err}`);
    return Promise.reject(new Error('useUser: Failed to fetch'));
  });

// Define a custom hook called useUser that takes in a userEmail parameter
export default function useUser(userEmail) {
  const { data } = useSWR(`${apiUrl}/users/${userEmail.user}`, fetcher);
  const userDetails = data;
  // If data is truthy, create a new object with the data and default values for projects and currentProject
  console.log('useremail', userEmail, apiUrl);
  const updateUser = (transData) => fetch(
    `${apiUrl}/users/${userEmail.user}`,
    {
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'test',
      },
      method: 'PUT',
      mode: 'cors',
      body: JSON.stringify({
        ...transData,
      }),
    },
  ).then((response) => {
    if (response.ok) {
      console.log('user value updated');
    }
  });
  // Return an object with user, isLoading, and isError properties
  return {
    data,
    updateUser,
    userDetails,
    // isLoading: !data && !error, isError: error,
  };
}
